import React, { useEffect } from 'react';

const SuccessAlert = ({ message, onClose, autoCloseDelay = 20000 }) => {
  useEffect(() => {
    const timerId = setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, autoCloseDelay);

    return () => clearTimeout(timerId);
  }, [onClose, autoCloseDelay]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="fixed top-20 right-4 z-[9999] w-full max-w-md animate-slide-in-right">
      <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded-lg shadow-xl" role="alert">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="ml-3 flex-1">
            <h3 className="text-sm font-bold text-green-800">Success</h3>
            <p className="text-sm text-green-700 mt-1 break-words">{message}</p>
          </div>
          {onClose && (
            <button
              className="ml-3 flex-shrink-0 inline-flex text-green-400 hover:text-green-600 focus:outline-none transition-colors"
              onClick={handleClose}
              aria-label="Close"
            >
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuccessAlert;
